"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttendeeReportActions;
(function (AttendeeReportActions) {
    AttendeeReportActions["DataLoaded"] = "DataLoaded";
})(AttendeeReportActions || (AttendeeReportActions = {}));
exports.default = AttendeeReportActions;
